/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the StatusCountsDTO interface.
 */
export function instanceOfStatusCountsDTO(value) {
    return true;
}
export function StatusCountsDTOFromJSON(json) {
    return StatusCountsDTOFromJSONTyped(json, false);
}
export function StatusCountsDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pending': json['pending'] == null ? undefined : json['pending'],
        'inProgress': json['inProgress'] == null ? undefined : json['inProgress'],
        'completed': json['completed'] == null ? undefined : json['completed'],
    };
}
export function StatusCountsDTOToJSON(json) {
    return StatusCountsDTOToJSONTyped(json, false);
}
export function StatusCountsDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pending': value['pending'],
        'inProgress': value['inProgress'],
        'completed': value['completed'],
    };
}
